import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';

type inputFieldType = {
  useFocus: boolean;
  parameters: TextFieldProps;
  performSearch: Function;
  clearSearch: Function;
  updateRecentSearches: Function;
};

const onSubmit = (
  event: any,
  performSearch: Function,
  clearSearch: Function,
  updateRecentSearches: Function,
) => {
  if (event.key === 'Enter') {
    clearSearch();
    performSearch(event.target.value);
    updateRecentSearches();
  }
};

const InputField = ({
  useFocus,
  parameters,
  performSearch,
  clearSearch,
  updateRecentSearches,
}: inputFieldType) => (
  <TextField
    variant="standard"
    autoFocus={useFocus}
    {...parameters}
    onChange={() => {
      clearSearch();
    }}
    onPaste={() => {
      clearSearch();
    }}
    onClick={(event: any) => {
      if (event.target.nodeName === 'path' || event.target.nodeName === 'svg') clearSearch();
    }}
    onKeyDown={(event) => onSubmit(event, performSearch, clearSearch, updateRecentSearches)}
    placeholder="Search"
    style={{ textAlign: 'center' }}
    fullWidth
  />
);

export default InputField;
